import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import { sendMessage, receiveMessage } from "../../apis/Admins/MessageApi";
import { useParams } from "react-router-dom";
import { getProfile } from "../../apis/User";
import CloseIcon from "@mui/icons-material/Close";
import emailIcon from "../../assets/design-revamp/top-mail-icon.svg";
import smallEmailIcon from "../../assets/design-revamp/mail-icon.svg";
import { useLocation } from "react-router-dom";

export function SendMessage({ setOpen }) {
  const { t } = useTranslation();
  const [supplier, setSupplier] = useState("");
  const [receiverEmail, setReceiverEmail] = useState("");
  const [colleague, setColleague] = useState("");
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [product, setProduct] = useState("");
  const [section, setSection] = useState("");
  const [body, setBody] = useState("");
  const [sender, setSender] = useState("");
  const [receivers, setReceivers] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const business = queryParams.get("business");
  const { businessId } = useParams();

  const handleChangeSupplier = (event) => {
    setSupplier(event.target.value);
  };

  const handleChangeColleague = (event) => {
    setColleague(event.target.value);
  };

  const handleSend = () => {
    sendMessage({
      businessId: businessId ? businessId : business,
      sender: sender,
      receiver: [supplier, colleague, receiverEmail],
      name: name,
      mail: mail,
      product: product,
      section: section,
      body: body,
      supplier: supplier,
      colleague: colleague,
    });
    setOpen(false);
  };

  useEffect(() => {
    getProfile({
      setEmail: setSender,
    });
    receiveMessage({
      setMessages: setReceivers,
      businessId: businessId ? businessId : business,
    });
  }, [businessId, business]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "20px 30px",
      }}
      className="mail-bg"
    >
      <CloseIcon
        onClick={() => setOpen(false)}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "50",
          paddingRight: "10px",
          width: "40px",
          height: "40px",
        }}
      />
      <div className="emailMessageIcon">
        <img src={emailIcon} width={60} height={60} alt="Email Icon" />
      </div>
      <div className="mail-body-bg">
        <p style={{ color: "#495c7f", maxWidth: "680px", marginTop: "20px" }}>
          {t("MESSAGE_1")}
        </p>
        <div style={{ display: "flex", marginBottom: "8px" }}>
          <div>
            <label
              style={{
                color: "#495c7f",
                marginRight: "5px",
                minWidth: "120px",
              }}
            >
              {t("MESSAGE_TO_SUPPLIER")}:
            </label>
            <select
              value={supplier}
              onChange={handleChangeSupplier}
              className="bg-field-mail"
            >
              {receivers &&
                receivers.length > 0 &&
                receivers.map((receiver, index) => (
                  <React.Fragment key={index}>
                    {receiver.receiver &&
                      receiver.receiver.length > 0 &&
                      receiver.receiver.map((email, idx) => (
                        <option key={idx} value={email}>
                          {email}
                        </option>
                      ))}
                  </React.Fragment>
                ))}
            </select>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <input
              type="text"
              value={supplier}
              onChange={(e) => setSupplier(e.target.value)}
              className="bg-field-mail"
            />
          </div>
        </div>
        <div style={{ display: "flex", marginBottom: "8px" }}>
          <div>
            <label
              style={{
                color: "#495c7f",
                marginRight: "5px",
                minWidth: "120px",
              }}
            >
              {t("MESSAGE_TO_COLLEAGUE")}:
            </label>
            <select
              value={colleague}
              onChange={handleChangeColleague}
              className="bg-field-mail"
            >
              {receivers &&
                receivers.length > 0 &&
                receivers.map((receiver, index) => (
                  <React.Fragment key={index}>
                    {receiver.receiver &&
                      receiver.receiver.length > 0 &&
                      receiver.receiver.map((email, idx) => (
                        <option key={idx} value={email}>
                          {email}
                        </option>
                      ))}
                  </React.Fragment>
                ))}
            </select>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <input
              type="text"
              value={colleague}
              onChange={(e) => setColleague(e.target.value)}
              className="bg-field-mail"
            />
          </div>
        </div>

        <div
          style={{ marginBottom: "5px", display: "flex", alignItems: "center" }}
        >
          <label
            style={{
              color: "#495c7f",
              marginRight: "10px",
              minWidth: "120px",
            }}
          >
            {t("MESSAGE_NAME")}:{" "}
          </label>

          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-field-mail"
          />
          <div style={{ minWidth: "38px" }}></div>
        </div>
        <div
          style={{ marginBottom: "5px", display: "flex", alignItems: "center" }}
        >
          <label
            style={{
              color: "#495c7f",
              marginRight: "10px",
              minWidth: "120px",
            }}
          >
            {t("MESSAGE_MAIL")}:{" "}
          </label>
          <input
            type="email"
            value={mail}
            onChange={(e) => setMail(e.target.value)}
            className="bg-field-mail"
          />
          <div style={{ minWidth: "38px" }}></div>
        </div>
        <div
          style={{ marginBottom: "5px", display: "flex", alignItems: "center" }}
        >
          <label
            style={{
              color: "#495c7f",
              marginRight: "10px",
              minWidth: "120px",
            }}
          >
            {t("MESSAGE_PRODUCT")}:{" "}
          </label>
          <input
            type="text"
            value={product}
            onChange={(e) => setProduct(e.target.value)}
            className="bg-field-mail"
          />
          <div style={{ minWidth: "38px" }}></div>
        </div>
        <div
          style={{
            marginBottom: "30px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <label
            style={{
              color: "#495c7f",
              marginRight: "10px",
              minWidth: "120px",
            }}
          >
            {t("MESSAGE_SECTION")}:{" "}
          </label>
          <input
            type="text"
            value={section}
            onChange={(e) => setSection(e.target.value)}
            className="bg-field-mail"
          />
          <div style={{ minWidth: "38px" }}></div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          <label style={{ color: "#495c7f" }}>{t("MESSAGE_2")}</label>
          <input
            type="text"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            className="bg-field-mail"
          />
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
        <h5
          style={{
            fontSize: "12px",
            color: "#203669",
            marginRight: "5px",
            fontWeight: "bold",
          }}
        >
          Send mail to:
        </h5>
        <div style={{ marginRight: "5px" }}>
          <input
            type="text"
            value={colleague}
            onChange={(e) => setReceiverEmail(e.target.value)}
            placeholder="name@email.com"
            className="bg-field-mail"
          />
        </div>
        <img
          src={smallEmailIcon}
          alt="Email Send Icon"
          width={22}
          height={22}
          onClick={handleSend}
        />
      </div>
    </div>
  );
}
